import {
  Legend,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Label,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";
import { useEffect, useState } from "react";

import { format } from "date-fns";

import IGuidance from "../../../types/IGuidance";

const labels: { [key: string]: string } = {
  fobPrice: "FOB Posted Px",
  altPrice: "Alternative",
};

const CustomTooltip = ({ active, payload }: any) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: "#148DD3",
          padding: 10,
          borderRadius: 8,
          color: "white",
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}
      >
        <div style={{ display: "flex", gap: 6 }}>
          <div style={{ fontWeight: 500 }}>Month:</div>
          {format(new Date(payload[0]?.payload?.date), "MMM dd yyyy")}
          {/* {payload[0]?.payload?.date} */}
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          <div style={{ fontWeight: 500 }}>FOB Posted Px:</div> {" $"}
          {Math.round((payload[0]?.payload?.fobPrice || 0) * 100) / 100}
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          <div style={{ fontWeight: 500 }}>Alternative:</div>
          {" $"}
          {Math.round((payload[0]?.payload?.altPrice || 0) * 100) / 100}
        </div>
        {/* <p className="label">{`${label} : ${payload[0].value}`}</p>
          <p className="intro">{getIntroOfPage(label)}</p> */}
      </div>
    );
  }

  return null;
};

const GuidanceChart = ({ data }: { data: IGuidance[] }) => {
  const [domain, setDomain] = useState<number[]>([0, 100]);

  useEffect(() => {
    const values: number[] = [
      ...data.map((r) => r.fobPrice),
      ...data.map((r) => r.altPrice),
    ];

    const minValue = Math.min(...values);
    const maxValue = Math.max(...values);
    setDomain([minValue, maxValue]);
  }, [data]);

  return (
    <ResponsiveContainer height={300}>
      <LineChart data={data} margin={{ bottom: 5, left: 0 }}>
        <Line
          type="monotone"
          dataKey="fobPrice"
          stroke="#005CA6"
          strokeWidth={1}
          dot={{ fill: "#005CA6", strokeWidth: 3 }}
        />
        <Line
          type="monotone"
          dataKey="altPrice"
          stroke="#148DD3"
          strokeWidth={1}
          dot={{ fill: "#148DD3", strokeWidth: 3 }}
        />
        <XAxis
          hide
          dataKey="month"
          fontSize={12}
          fontWeight={700}
          color="#231F20"
          axisLine={false}
          tickLine={false}
          padding={{
            left: 140,
            right: 60,
          }}
        />
        <YAxis
          domain={domain}
          axisLine={false}
          tickLine={false}
          fontSize="1em"
          fontWeight={300}
          color="#231F20"
          ticks={[
            domain[0] - 1,
            ...[...Array(4).keys()].map((i) =>
              Math.round(domain[0] + ((domain[1] - domain[0]) / 3) * i)
            ),
          ]}
          tickFormatter={(value: any) => {
            return `$${value}`;
          }}
          padding={{ top: 10 }}
          //   width={145}
          textAnchor="start"
        >
          <Label angle={-90} value="Price" style={{ textAnchor: "start" }} />
        </YAxis>

        <Legend
          verticalAlign="top"
          wrapperStyle={{ fontSize: "1em", fontWeight: 700 }}
          iconSize={16}
          formatter={(value: any) => {
            return labels[value] || value;
          }}
        />
        <Tooltip content={<CustomTooltip />} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default GuidanceChart;
